/* global Raven */
import ApolloClient from "apollo-boost";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import store from "./store";
import { logOut } from "./ducks/auth";
import { ensureAccessToken } from "./auth";

const env = runtimeEnv();

export default new ApolloClient({
  uri: `${env.REACT_APP_API_HOST}/graphql`,
  request: operation => {
    return ensureAccessToken().then(token => {
      operation.setContext(context => ({
        headers: {
          ...context.headers,
          authorization: token ? `Bearer ${token}` : null
        }
      }));
    });
  },
  onError: ({ graphQLErrors, networkError, response }) => {
    if (graphQLErrors && typeof Raven !== "undefined") {
      graphQLErrors.map(({ message, locations, path }) =>
        Raven.captureMessage(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          { level: "warning" }
        )
      );
      return;
    }

    if (response && response.status === 401) {
      store.dispatch(logOut());
    }
  }
});



// WEBPACK FOOTER //
// ./src/apolloClient.js